import React, { useContext, forwardRef, useRef, useEffect } from 'react'
import { AppContext } from '../App'
import { handleImageUpload } from '.'

const ImageInput = forwardRef((field, ref) => {
  const { state, dispatch } = useContext(AppContext)
  const fileInputRef = useRef(null)

  useEffect(() => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }, [state.currentProject.projectId])

  const changeImage = (e) => {
    if (e.target.files.length === 0) return

    field.onChange(e.target.files[0])
    handleImageUpload(dispatch, e.target.files[0], state.currentProject.projectId)
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type='file'
        className='file-input file-input-bordered w-full max-w-sm shadow'
        accept='image/*'
        onChange={changeImage}
      />
    </>
  )
})

export { ImageInput }
